module.exports = __webpack_public_path__ + "static/media/Blop.627c0e8b.mp3";